document.addEventListener("DOMContentLoaded", function () {
  function showPopup(popupId) {
    const popup = document.getElementById(popupId);
    if (!popup) return;

    popup.removeAttribute("hidden");
    setTimeout(() => {
      popup.setAttribute("hidden", "");
    }, 3000);
  }

  const mainCartBtn = document.getElementById("main-cart-note-btn");
  const mainCartTextarea = document.getElementById("CartSpecialInstructions");

  if (mainCartBtn && mainCartTextarea) {
    mainCartBtn.addEventListener("click", function () {
      const note = mainCartTextarea.value;
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ note })
      })
        .then(res => res.json())
        .then(() => showPopup("main-note-popup"));
    });
  }

  const drawerBtn = document.querySelector(".order-note-toggle__content .button");
  const drawerTextarea = document.getElementById("mini-cart__notes");

  if (drawerBtn && drawerTextarea) {
    drawerBtn.addEventListener("click", function () {
      const note = drawerTextarea.value;
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ note })
      })
        .then(res => res.json())
        .then(() => showPopup("drawer-note-popup"));
    });
  }
});
